import api from './api';

class AuthService {
  login = async (email, password) => {
    try {
      const response = await api.post('/auth/login', { email, password });
      
      if (response.data.success) {
        const { accessToken, refreshToken, expiresIn, data } = response.data;
        
        // Calculate expiry time
        const expiryTime = Date.now() + expiresIn;
        
        // Store tokens and user data
        localStorage.setItem(process.env.REACT_APP_TOKEN_KEY, accessToken);
        localStorage.setItem(process.env.REACT_APP_REFRESH_TOKEN_KEY, refreshToken);
        localStorage.setItem(process.env.REACT_APP_TOKEN_EXPIRY_KEY, expiryTime.toString());
        localStorage.setItem('user', JSON.stringify(data));
        
        return {
          success: true,
          user: data,
          accessToken,
          refreshToken
        };
      }
      
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  };
  
  logout = () => {
    // Clear all auth data
    localStorage.removeItem(process.env.REACT_APP_TOKEN_KEY);
    localStorage.removeItem(process.env.REACT_APP_REFRESH_TOKEN_KEY);
    localStorage.removeItem(process.env.REACT_APP_TOKEN_EXPIRY_KEY);
    localStorage.removeItem('user');
    
    // Clear axios default header
    delete api.defaults.headers.common['Authorization'];
    
    // Redirect to login
    window.location.href = '/login';
  };
  
  getCurrentUser = () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  };
  
  isAuthenticated = () => {
    const token = localStorage.getItem(process.env.REACT_APP_TOKEN_KEY);
    const tokenExpiry = localStorage.getItem(process.env.REACT_APP_TOKEN_EXPIRY_KEY);
    
    if (!token || !tokenExpiry) return false;
    
    // Check if token is expired (with 1 minute buffer)
    return Date.now() < (parseInt(tokenExpiry) - 60000);
  };
  
  handleError = (error) => {
    if (error.response) {
      // Server responded with error
      const { status, data } = error.response;
      
      switch (status) {
        case 400:
          return new Error(data.message || 'Bad request');
        case 401:
          return new Error('Invalid credentials');
        case 403:
          return new Error('Access denied');
        case 404:
          return new Error('Resource not found');
        case 500:
          return new Error('Server error');
        default:
          return new Error(data.message || 'An error occurred');
      }
    } else if (error.request) {
      // Request made but no response
      return new Error('No response from server. Please check your connection.');
    } else {
      // Error in setting up request
      return new Error('Request error: ' + error.message);
    }
  };
}

export default new AuthService();
